// Centralized report module + field definitions. Used by ReportsPage and
// any future "saved report" feature.
export const REPORT_MODULES = {
  clients: {
    label: 'Clients',
    fields: [
      { id: 'name', label: 'Client Name', type: 'string' },
      { id: 'email', label: 'Email', type: 'string' },
      { id: 'phone', label: 'Phone', type: 'string' },
      { id: 'company_name', label: 'Company', type: 'string' },
      { id: 'position', label: 'Position', type: 'string' },
      { id: 'gst_number', label: 'GST Number', type: 'string' },
      { id: 'pan_number', label: 'PAN Number', type: 'string' },
      { id: 'status', label: 'Status', type: 'string' },
      { id: 'created_at', label: 'Created Date', type: 'date' }
    ]
  },
  companies: {
    label: 'Companies',
    fields: [
      { id: 'name', label: 'Company Name', type: 'string' },
      { id: 'industry', label: 'Industry', type: 'string' },
      { id: 'website', label: 'Website', type: 'string' },
      { id: 'phone', label: 'Phone', type: 'string' },
      { id: 'business_address', label: 'Address', type: 'string' },
      { id: 'gst_number', label: 'GST Number', type: 'string' },
      { id: 'pan_number', label: 'PAN Number', type: 'string' },
      { id: 'status', label: 'Status', type: 'string' }
    ]
  },
  projects: {
    label: 'Projects',
    fields: [
      { id: 'project_code', label: 'Project Code', type: 'string' },
      { id: 'name', label: 'Project Name', type: 'string' },
      { id: 'client_name', label: 'Client', type: 'string' },
      { id: 'budget', label: 'Budget', type: 'number' },
      { id: 'status', label: 'Status', type: 'string' },
      { id: 'start_date', label: 'Start Date', type: 'date' },
      { id: 'end_date', label: 'End Date', type: 'date' },
      { id: 'completion_percentage', label: 'Completion %', type: 'number' },
      { id: 'created_at', label: 'Created Date', type: 'date' }
    ]
  },
  tasks: {
    label: 'Tasks',
    fields: [
      { id: 'title', label: 'Task Title', type: 'string' },
      { id: 'project_name', label: 'Project', type: 'string' },
      { id: 'status', label: 'Status', type: 'string' },
      { id: 'priority', label: 'Priority', type: 'string' },
      { id: 'assignee_name', label: 'Assignee', type: 'string' },
      { id: 'start_date', label: 'Start Date', type: 'date' },
      { id: 'end_date', label: 'End Date', type: 'date' },
      { id: 'created_at', label: 'Created Date', type: 'date' }
    ]
  },
  time_logs: {
    label: 'Time Logs',
    fields: [
      { id: 'project_code', label: 'Project Code', type: 'string' },
      { id: 'project_name', label: 'Project', type: 'string' },
      { id: 'user_name', label: 'Team Member', type: 'string' },
      { id: 'task_title', label: 'Task', type: 'string' },
      { id: 'duration_minutes', label: 'Duration', type: 'number' },
      { id: 'billable', label: 'Billable', type: 'boolean' },
      { id: 'date', label: 'Date', type: 'date' }
    ]
  },
  team: {
    label: 'Team Members',
    fields: [
      { id: 'name', label: 'Name', type: 'string' },
      { id: 'email', label: 'Email', type: 'string' },
      { id: 'role', label: 'Role', type: 'string' },
      { id: 'date_of_joining', label: 'Date of Joining', type: 'date' }
    ]
  },
  leaves: {
    label: 'Leave Applications',
    fields: [
      { id: 'user_name', label: 'Employee', type: 'string' },
      { id: 'leave_type', label: 'Leave Type', type: 'string' },
      { id: 'start_date', label: 'Start Date', type: 'date' },
      { id: 'end_date', label: 'End Date', type: 'date' },
      { id: 'days', label: 'Days', type: 'number' },
      { id: 'status', label: 'Status', type: 'string' },
      { id: 'reason', label: 'Reason', type: 'string' }
    ]
  },
  reimbursements: {
    label: 'Reimbursements',
    fields: [
      { id: 'user_name', label: 'Employee', type: 'string' },
      { id: 'category', label: 'Category', type: 'string' },
      { id: 'amount', label: 'Amount', type: 'number' },
      { id: 'date', label: 'Date', type: 'date' },
      { id: 'status', label: 'Status', type: 'string' },
      { id: 'description', label: 'Description', type: 'string' },
      { id: 'project_id', label: 'Project Tagged', type: 'boolean' }
    ]
  },
  fee_structure: {
    label: 'Fee Structure',
    fields: [
      { id: 'stage', label: 'Stage', type: 'string' },
      { id: 'deliverable', label: 'Deliverable', type: 'string' },
      { id: 'percentage', label: 'Percentage', type: 'number' },
      { id: 'amount', label: 'Amount', type: 'number' },
      { id: 'tentative_billing_date', label: 'Billing Date', type: 'date' },
      { id: 'deliverable_status', label: 'Deliverable Status', type: 'string' },
      { id: 'invoice_status', label: 'Invoice Status', type: 'string' },
      { id: 'payment_status', label: 'Payment Status', type: 'string' }
    ]
  }
};

// API endpoints per module (used by fetchModuleData)
export const MODULE_ENDPOINTS = {
  clients: '/clients?limit=5000',
  companies: '/companies?limit=5000',
  projects: '/projects?limit=5000',
  tasks: '/tasks?include_internal=true&limit=5000',
  time_logs: '/time-logs?limit=5000',
  team: '/team',
  leaves: '/leaves?limit=5000',
  reimbursements: '/reimbursements?limit=5000',
  fee_structure: '/fee-structure?limit=5000'
};
